import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/union-pay.png")